// extracted by mini-css-extract-plugin
module.exports = {"Row":"ClientPurchases_Row__3Eor1","ChangeDateButton":"ClientPurchases_ChangeDateButton__1MoYW"};